<template>
    <div class="text-start">
        <div class="row text-start">
            <div class="col-lg-5 checkout-content" style="min-height:300px; padding-left:30px;padding-top:10px;" :style="{'background-image': 'url(' + this.Store.Checkout.BackgroundImage + ')'}">
                <div class="text-start text-muted fw-bold small"><i class="bi-cart-check" style="color:black;"></i> Your Order:</div>
                <h5 style="color:black;margin-left:15px;">
                    Remote Online Notarization
                </h5>

                <div class="text-start text-muted fw-bold small"><i class="bi-geo-alt" style="color:black"></i> Service Venue:</div>
                <h5 class="" style="color: black; margin-left: 15px;">
                    Online Video Conference
                </h5>

                <div class="text-start text-muted fw-bold small">Notes:</div>
                <ul class="" style="list-style: none; font-size: 12px; color: darkslategray; padding-left: 15px; ">
                    <li><i class="bi bi-info-circle"></i> Legally valid &amp; accepted Nationwide</li>
                    <li><i class="bi bi-info-circle"></i> Mobile carrier data charges may apply</li>
                    <li><i class="bi bi-info-circle"></i> Notarized documents returned as PDF</li>
                </ul>

                <div class="text-start text-muted fw-bold small">Requirements:</div>
                <ul class="" style="list-style: none; font-size: 12px; color: darkslategray; padding-left: 15px;">
                    <li><i class="bi bi-check-circle"></i> Stable internet connection</li>
                    <li><i class="bi bi-check-circle"></i> Video &amp; audio enabled camera</li>
                    <li><i class="bi bi-check-circle"></i> Valid, government issued identification</li>
                </ul>
            </div>
            <div class="col-lg-7">
                <div style="" class="row justify-content-center align-items-sm-center col-sm-divider text-center text-sm-start mt-4 mb-3">
                    <div class="col-sm-auto text-center">
                        <h5 class="mb-0">Notaries Online:</h5>

                        <div v-if="!DataLoaded" class="spinner-border spinner-border-sm" role="status"></div>
                        <span v-else class="d-block fs-5 mt-2"><i :class="NumNotaries > 0? 'text-primary bi-check-circle' : 'text-red bi-x-circle'"></i> {{NumNotaries > 0? 'Yes' : 'No'}}</span>

                    </div>
                    <!-- End Col -->

                    <div class="col-sm-auto text-center">
                        <h5 v-if="NumNotaries > 0" class="mb-0">Estimated Wait Time:</h5>
                        <h5 v-else="NumNotaries > 0" class="mb-0">Notaries Returning:</h5>

                        <div v-if="!DataLoaded" class="spinner-border spinner-border-sm" role="status"></div>
                        <span v-else>
                            <span v-if="NumNotaries > 0" class="d-block fs-5 mt-2"> {{WaitTime}}</span>
                            <span v-else class="d-block fs-5 mt-2"> {{NextServiceTime}}</span>
                        </span>


                    </div>

                    <div v-if="DataLoaded" class="p-0">
                        <div v-if="NumNotaries <= 0">
                            <div class="text-danger mt-5 pt-3 pb-3 mb-5 shadow">
                                <h4 class="text-center text-warning"> There are currently no notaries online.</h4>
                                <div class="text-muted fw-bold text-center p-3" style="font-size:12px;">but, <span class="text-success" style="background-color:yellow">you can schedule an appointment for a remote notarization at a later time.</span></div>
                            </div>
                        </div>
                        <div v-if="NumNotaries > 0">
                            <div class="text-success shadow mt-4 pt-2">
                                <h4 class="text-center text-success"><i class="bi bi-check-circle"></i> Notaries Are Online &amp; Standing By</h4>
                                <div class="text-muted text-center p-3" style="font-size:12px;"><span class="text-success" style="background-color:yellow">Instant Remote Online Notarizations are available. </span><br />Or, you can schedule an appointment for a later time.</div>
                            </div>
                        </div>
                    </div>

                    <div class="position-relative text-center px-3" style="">

                        <div class="p-2 mb-1 mt-3">
                            <div v-if="NotaryConfig.offerLoanClosings" class="fw-bold p-0 mb-1" style="color:limegreen">&nbsp;What Type Of Signing Are You Requesting?</div>
                            <div v-if="!NotaryConfig.offerLoanClosings" class="fw-bold p-0 mb-1" style="color:limegreen">&nbsp;This is a "General Notary Appointment"</div>
                            <table style="width:100%" class="mt-1 mb-3">
                                <tr>
                                    <!-- GNW -->
                                    <td :class="Store.Checkout.Cart.NotaryServiceType == 0? 'shadow':''">
                                        <input v-model="Store.Checkout.Cart.NotaryServiceType" :value="0" type="radio" class="btn-check" name="btnradio" id='option1' autocomplete="off">
                                        <label style="width:100%" class="btn btn-outline-primary" for="option1">
                                            General Notarization<br>
                                            <span style="font-size:12px" class="fw-light">
                                                ${{NotaryConfig.notaryTechFee.toString().toSmartFixed(2)}} for most documents
                                            </span><br />
                                        </label>
                                    </td>

                                    <!-- Loan Package -->
                                    <td :class="Store.Checkout.Cart.NotaryServiceType == 1? 'shadow':''" v-if="NotaryConfig.offerLoanClosings">
                                        <input v-model="Store.Checkout.Cart.NotaryServiceType" :value="1" type="radio" class="btn-check" name="btnradio" id="option2" autocomplete="off">
                                        <label style="width:100%" class="btn btn-outline-primary" for="option2">
                                            Mortgage Loan Package<br>
                                            <span style="font-size:12px" class="fw-light">
                                                ${{NotaryConfig.notaryLoanClosingCost.toFixed(2)}} flat fee<br />
                                            </span>
                                        </label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                    <!-- End Col -->
                </div>

               
        </div>
    </div>
</template>

<script>
    import { useEditorStore } from '/src/stores/EditorStore';
    import EventHub from '/src/Util/EventHub.js';
    import axios from '/src/components/NovaAxios.js';
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';

    export default {
        name: 'VenueSelectRON',
        components: {
        },
        watch:{            
        },
        props: {
        },
        data() {
            return {
                Store: {},
                NumNotaries: 0,
                NumInLine: 0,
                WaitTimeMinutes: 0,
                NextServiceTime: '',
                DataLoaded: false,
            };
        },
        methods:
        {
            OnCmdNext: async function () {
                this.Store.Checkout.Cart.Price = this.RONTotal;
                this.Store.SetCurrentStep((this.Store.Checkout.Cart.CurrentStep || 0) + 1)     
            },

             OnStepActivated: async function(){
                 if(this.Store.Checkout.Cart.CurrentStep == 1){
                     //init
                 }
             },
            FetchNotaryQ: function () {
              var that = this;
              var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
              EventHub.$emit("PageLoading", true);
              axios.postForm('/API/GetNotaryQ', {},
                  {
                      cache: false,
                      headers: {
                          'RequestVerificationToken': token
                      }
                  }).then(function (response) {
                      if (response.data.success) {
                          that.DataLoaded = true;
                          EventHub.$emit("PageLoading", false);
                          that.WaitTimeMinutes = response.data.waittime;
                          that.NumInLine = response.data.numinline;
                          that.NumNotaries = response.data.numproviders;
                          that.NextServiceTime = response.data.nextavailable;                            
                      }
                      else {
                          EventHub.$emit("PageLoading", false);
                          toast.error("Failed to load notary queue info. " + response.data.msg);
                      }
                  }).catch(function (error) {
                      EventHub.$emit("PageLoading", false);
                      toast.error("Failed to load notary queue info. Please refresh the page and try again.");
                  });
          },
        },
        computed:
        {
            NotaryConfig: function () {
                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigNotary) {
                    return this.Store.TenantConfig.serviceConfigNotary;
                }

                return {};
            },
            RONTotal: function(){
                if(this.Store.Checkout.Cart.SelectedService == 'RONNotarization'){
                   switch(this.Store.Checkout.Cart.NotaryServiceType){
                        case 1: return this.NotaryConfig.notaryLoanClosingCost.toFixed(2)
                        case 0: return this.NotaryConfig.notaryTechFee.toFixed(2); // unknown price until RON notarization is compelte
                    }
                }

            },
            WaitTime: function () {
                if (this.WaitTimeMinutes < 1) {
                    return "< 1 minute";
                }

                var msg = `aprox. ${this.WaitTimeMinutes.toFixed(0)} minutes.)`;
                if (this.NumInLine == 1) {
                    msg += " You are next in line.";
                } else {
                    msg += `${this.NumInLine} people in line currently.`;
                }
            },
        },
        beforeMount: function () {

        },
        created: function () {
            this.Store = useEditorStore();
        },
        mounted: function () {
            this.Store.Checkout.NextButton.Text = "Continue";
            this.Store.Checkout.NextButton.Icon = "bi-calendar-check";
            this.Store.Checkout.NextButton.IsVisible = true;
            EventHub.$on('OnCmdNext', this.OnCmdNext);
            EventHub.$on('OnStepActivated', this.OnStepActivated);
            this.FetchNotaryQ();
        },
        beforeUnmount: function () {
            EventHub.$off('OnStepActivated', this.OnStepActivated);
            EventHub.$off('OnCmdNext', this.OnCmdNext);
        }
    }
</script>

<style>
  
</style>